const NAME = 'GlukyChallenges';
class GlukyConfigService {
  get(key, fallback) {
    var _a, _b;
    const value = (_b = (_a = window[NAME]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[key];
    return value !== undefined ? value : fallback;
  }
  getBoolean(key, fallback = false) {
    var _a, _b;
    const val = (_b = (_a = window[NAME]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[key];
    if (val === undefined) {
      return fallback;
    }
    if (typeof val === 'string') {
      return val === 'true';
    }
    return !!val;
  }
  getNumber(key, fallback) {
    var _a, _b;
    const val = parseFloat((_b = (_a = window[NAME]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[key]);
    return isNaN(val) ? (fallback !== undefined ? fallback : NaN) : val;
  }
  set(key, value) {
    var _a, _b;
    if ((_b = (_a = window[NAME]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[key]) {
      window[NAME].config[key] = value;
    }
  }
}
const config = /*@__PURE__*/ new GlukyConfigService();

export { NAME as N, config as c };
